import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/basic";

class Client {
  @observable searchData = "";
  @observable modalVisible = false;
  @observable tableData = [];
  @observable formData = {};
  @observable PageInfo = {};
  @observable addAddressModalVisible = false;
  @observable addressDetailModalVisible = false;
  @observable addressData = [];
  @observable addressFormData = {};

  @action.bound async getParams(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.clientList,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 新增参数
  @action.bound async addParams(params) {
    this.isLoading = true;
    const url = services.requestUrl.saveClient;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 删除参数
  @action.bound async deleteParams(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(
        services.requestUrl.deleteClient,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound async getAddressList(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.clientAddressList,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.addressData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 新增参数
  @action.bound async addAddress(params) {
    this.isLoading = true;
    const url = services.requestUrl.saveAddressClient;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 删除参数
  @action.bound async deleteAddress(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(
        services.requestUrl.deleteAddressClient,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 通用使用------ */
  //打开/关闭模态框
  @action.bound modalChange(type, record) {
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  }
}

let ClientStore = new Client();
export default ClientStore;
